import { useState, useCallback } from 'react';

export function useDashboardPagination(initialPage = 1) {
  // Current page state
  const [page, setPage] = useState(initialPage);

  // Safely updates page while obeying boundaries
  const setNewPage = useCallback((newPage: number, maxPage?: number | null) => {
    // Do nothing until API returns pagination metadata
    if (!maxPage) return;

    // Prevent going outside valid range
    if (newPage < 1 || newPage > maxPage) return;

    setPage(newPage);
  }, []);

  return {
    page,
    setNewPage,
  };
}
